interface EmailInputStepProps {
  email: string;
  isLoading: boolean;
  onEmailChange: (value: string) => void;
  onSubmit: () => void;
  className?: string;
}

export function EmailInputStep({ 
  email, 
  isLoading,
  onEmailChange, 
  onSubmit,
  className = '' 
}: EmailInputStepProps) {
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className={`space-y-6 ${className}`}>
      {/* 안내 메시지 */}
      <div className="text-center text-[14px] text-gray-600 mb-6">
        가입 시 사용한 이메일 주소로<br />
        인증번호를 보내드립니다
      </div>

      {/* 이메일 입력 */}
      <div>
        <label className="block text-[16px] font-medium text-[#222222] mb-3">
          이메일 주소
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          placeholder="example@ecodeal.co.kr"
          className="w-full h-[50px] px-4 text-[16px] border-[1.5px] border-[#DEDEDE] rounded-xl focus:outline-none focus:border-[#51C854] placeholder:text-[#999999]"
          required
        />
      </div>

      {/* 인증 버튼 */}
      <button
        type="submit"
        disabled={isLoading || !email.trim()}
        className="w-full h-[50px] bg-[#51C854] text-white font-semibold text-[16px] rounded-xl hover:bg-[#46B649] disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        {isLoading ? '인증중...' : '인증하기'}
      </button>

      {/* 추가 안내 */}
      <div className="text-center text-[12px] text-gray-500 mt-4 space-y-1">
        <div>스팸메일함도 확인해보세요</div>
        <div>인증번호는 10분 유효, 1시간 내 최대 3회 발송 가능합니다.</div>
      </div>
    </form>
  );
}
